import Keycloak from 'keycloak-js'

const staging = new Keycloak({
    realm: "Cloudogu",
    url: "https://staging-account.cloudogu.com/auth/",
    clientId: "staging-docs.cloudogu.com",
})

const productive = new Keycloak({
    realm: "Cloudogu",
    url: "https://account.cloudogu.com/auth/",
    clientId: "docs.cloudogu.com",
})

const keycloaks = {
    staging: staging,
    productive: productive,
};

export default keycloaks
